<template>
  <div class="flex-grow-1 d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="matrix"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h1 class="page-heading mr-auto">Матрицы</h1>
      <router-link
        v-if="$root.checkPermission('web_matrix_edit')"
        class="btn btn-primary mr-2"
        :to="`/settings/matrices/create`"
      >
        Добавить матрицу
      </router-link>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column label="Наименование" prop="name"/>
        <el-table-column align="center" width="330">
          <template slot-scope="{row, $index}">
            <btn-action
              class="btn btn-sm btn-outline-light mr-2"
              @click="remove(row, $index)"
            >
              Удалить
            </btn-action>
            <router-link
              class="btn btn-sm btn-outline-light mr-2"
              :to="`/settings/matrices/${row.id}?copy=true`"
            >
              Копировать
            </router-link>
            <router-link
              class="btn btn-sm btn-outline-light"
              :to="`/settings/matrices/${row.id}`"
            >
              Редактировать
            </router-link>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import BtnAction from '../../../components/btn-action'
  import api from '@/api'

  export default {
    components: {BtnAction},
    metaInfo: {title: 'Матрицы'},
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
      }
    },
    methods: {
      remove (matrix, index) {
        if (window.confirm('Удалить матрицу?')) {
          return api.delete('matrix/' + matrix.id).then((data) => {
            this.data.data.splice(index, 1)
          })
        }
      },
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/matrices/index.vue